module.exports = "//static.hsappstatic.net/marketplace-ui-common/static-1.11723/img/callout-wave.svg"